import { motion } from "framer-motion";

const EASE = [0.65, 0, 0.35, 1];

export const FadeIn = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, as: Tag = "span", className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskedLineScroll = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block ${className}`}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.span>
);

export const Overline = ({ children, dark = false }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-white/50" : "text-steel"}`}>
    {children}
  </p>
);
